import React, { useState }  from 'react';
import TogglerBody from '../TogglerBody';
import FlagCustomisationItemCounter from './FlagCustomisationItemCounter';
// import FlagCustomisationItem from './FlagCustomisationItem';
import './flagCustomisation.scss'

const flagItemArr = [
    {
        title: 'User Manipulation',
        targetTogler: 'Monitor kicks, bans and timeouts',
        counter: [
            {
                title: 'Kick Frequency',
                target: 'kicks',
                time: 'min',
                tipsTitle: 'Cross-Server detection',
                label: 'Safe',
                text: '<p>Kick Frequency setting enables you to define the threshold for the number of kicks a user needs to initiate before Themis takes action.</p>',
                textSecond: '<p>A member approximately needs to kick <span> 5 </span> users in less than <span> 60 seconds </span> before getting <span> Kick </span>. </p>',
                keyName: 'kickFrequency',
                keyTime: 'kickFrequencyPer',
            },
            {
                title: 'Ban Frequency',
                target: 'bans',
                time: 'day',
                tipsTitle: 'Ban Frequency',
                label: 'Safe',
                text: '<p>Ban Frequency setting enables you to define the threshold for the number of bans a user needs to initiate before Themis takes action.</p>',
                textSecond: '<p>A member approximately needs to kick <span> 5 </span> users in less than <span> 60 seconds </span> before getting <span> Kick </span>. </p>',
                keyName: 'banFrequency',
                keyTime: 'banFrequencyPer',
            },
            {
                title: 'Timeout Frequency',
                target: 'bans',
                time: 'day',
                tipsTitle: 'Timeout Frequency',
                label: 'Safe',
                text: '<p>Timeout Frequency setting enables you to define the threshold for the number of timeout a user needs to initiate before Themis takes action.</p>',
                textSecond: '<p>A member approximately needs to kick <span> 5 </span> users in less than <span> 60 seconds </span> before getting <span> Kick </span>. </p>',
                keyName: 'timeoutFrequency',
                keyTime: 'timeoutFrequencyPer',
            },
        ],
        targetSlader: 'Flag Sensitivity',
        currentAction: 'Kick',
        chooseActionTarget: '',
        trigger: 'userTrigger',
        sliderKeyName: 'userManipulationSensitivity',
    },
    {
        title: 'Role Manipulation',
        targetTogler: 'Monitor role management',
        counter: [
            {
                title: 'Creation Frequency',
                target: 'roles',
                time: 'min',
                tipsTitle: 'Creation Frequency',
                label: 'Safe',
                text: '<p>Creation Frequency setting empowers you to set the threshold for the number of roles a user must create before Themis takes action.</p>',
                textSecond: '<p>A member approximately needs to kick <span> 5 </span> users in less than <span> 60 seconds </span> before getting <span> Kick </span>. </p>',
                keyName: 'rCreationFrequency',
                keyTime: 'rCreationFrequencyPer',
            },
            {
                title: 'Deletion Frequency',
                target: 'roles',
                time: 'day',
                tipsTitle: 'Deletion Frequency',
                label: 'Safe',
                text: '<p>Deletion Frequency setting empowers you to set the threshold for the number of roles a user must delete before Themis takes action</p>',
                textSecond: '<p>A member approximately needs to kick <span> 5 </span> users in less than <span> 60 seconds </span> before getting <span> Kick </span>. </p>',
                keyName: 'rDeletionFrequency',
                keyTime: 'rDeletionFrequencyPer',
            },
            {
                title: 'Modification Frequency',
                target: 'roles',
                time: 'day',
                tipsTitle: 'Modification Frequency',
                label: 'Safe',
                text: '<p>Modification Frequency setting empowers you to set the threshold for the number of roles a user must modify before Themis takes action</p>',
                textSecond: '<p>A member approximately needs to kick <span> 5 </span> users in less than <span> 60 seconds </span> before getting <span> Kick </span>. </p>',
                keyName: 'rModificationFrequency',
                keyTime: 'rModificationFrequencyPer',
            },
        ],
        targetSlader: 'Sensitivity',
        currentAction: 'Log',
        chooseActionTarget: '',
        trigger: 'roleTrigger',
        sliderKeyName: 'roleManipulationSensitivity',
    },
    {
        title: 'Channel Management',
        targetTogler: 'Monitor channel management',
        counter: [
            {
                title: 'Creation Frequency',
                target: 'channels',
                time: 'min',
                tipsTitle: 'Creation Frequency',
                label: 'Safe',
                text: '<p>Creation Frequency setting empowers you to set the threshold for the number of channels a user must create before Themis takes action</p>',
                textSecond: '<p>A member approximately needs to kick <span> 5 </span> users in less than <span> 60 seconds </span> before getting <span> Kick </span>. </p>',
                keyName: 'cCreationFrequency',
                keyTime: 'cCreationFrequencyPer',
            },
            {
                title: 'Deletion Frequency',
                target: 'channels',
                time: 'day',
                tipsTitle: 'Deletion Frequency',
                label: 'Safe',
                text: '<p>Deletion Frequency setting empowers you to set the threshold for the number of channels a user must delete before Themis takes action</p>',
                textSecond: '<p>A member approximately needs to kick <span> 5 </span> users in less than <span> 60 seconds </span> before getting <span> Kick </span>. </p>',
                keyName: 'cDeletionFrequency',
                keyTime: 'cDeletionFrequencyPer',
            },
            {
                title: 'Modification Frequency',
                target: 'channels',
                time: 'day',
                tipsTitle: 'Modification Frequency',
                label: 'Safe',
                text: '<p>Modification Frequency setting empowers you to set the threshold for the number of channels a user must modify before Themis takes action</p>',
                textSecond: '<p>A member approximately needs to modify <span> 5 </span> channels in less than <span> 60 seconds </span> before getting <span> Kick </span>. </p>',
                keyName: 'cModificationFrequency',
                keyTime: 'cModificationFrequencyPer',
            },
        ],
        targetSlader: 'Sensitivity',
        currentAction: 'Warn',
        chooseActionTarget: '',
        trigger: 'channelTrigger',
        sliderKeyName: 'channelManipulationSensitivity',
    },
    {
        title: 'Webhook Management',
        targetTogler: 'Monitor webhook management',
        counter: [
            {
                title: 'Creation Frequency',
                target: 'webhooks',
                time: 'min',
                tipsTitle: 'Creation Frequency',
                label: 'Safe',
                text: '<p>Creation Frequency setting empowers you to set the threshold for the number of web-hooks a user must create before Themis takes action</p>',
                textSecond: '<p>A member approximately needs to create <span> 5 </span> web-hooks in less than  <span> 60 seconds </span> before getting <span> Kick </span>. </p>',
                keyName: 'wCreationFrequency',
                keyTime: 'wCreationFrequencyPer',
            },
            {
                title: 'Deletion Frequency',
                target: 'webhooks',
                time: 'day',
                tipsTitle: 'Deletion Frequency',
                label: 'Safe',
                text: '<p>Deletion Frequency setting empowers you to set the threshold for the number of web-hooks a user must delete before Themis takes action</p>',
                textSecond: '<p>A member approximately needs to delete <span> 5 </span> web-hooks in less than <span> 60 seconds </span> before getting <span> Kick </span>. </p>',
                keyName: 'wDeletionFrequency',
                keyTime: 'wDeletionFrequencyPer',
            },
            {
                title: 'Modification Frequency',
                target: 'webhooks',
                time: 'day',
                tipsTitle: 'Modification Frequency',
                label: 'Safe',
                text: '<p>Modification Frequency setting empowers you to set the threshold for the number of web-hooks a user must modify before Themis takes action</p>',
                textSecond: '<p>A member approximately needs to modify <span> 5 </span> web-hooks in less than <span> 60 seconds </span> before getting <span> Kick </span>. </p>',
                keyName: 'wModificationFrequency',
                keyTime: 'wModificationFrequencyPer',
            },
        ],
        targetSlader: 'Sensitivity',
        currentAction: 'Ban',
        chooseActionTarget: '',
        trigger: 'webhookTrigger',
        sliderKeyName: 'webhookManipulationSensitivity',
    },
    {
        title: 'Mass Spam',
        targetTogler: 'Monitor tag messages ',
        counter: [
            {
                title: 'Tag Message Frequency',
                target: 'tags',
                time: 'min',
                tipsTitle: 'Tag Message Frequency',
                label: 'Safe',
                text: '<p>Tag Message Frequency setting allows you to determine the threshold for the number of tag mentions, such as @everyone or @Role, a user must include before Themis takes action</p>',
                textSecond: '<p>A member approximately needs to send  <span> 5 </span> messages with tags in less than <span> 60 seconds </span> before getting <span> Kick </span>. </p>',
                keyName: 'tagFrequency',
                keyTime: 'tagFrequencyPer',
            },
        ],
        targetSlader: 'Flag Sensitivity',
        currentAction: 'Kick',
        chooseActionTarget: '',
        trigger: 'massSpamTrigger',
        sliderKeyName: 'massSpamSensitivity',
    },
    {
        title: 'Cross-Server Monitor',
        targetTogler: 'Target suspicious account',
        counter: [],
        targetSlader: '',
        currentAction: '',
        chooseActionTarget: 'Punishment',
        trigger: 'crossServerTrigger',
        keyName: 'crossServerPunishment'
    },
];

const FlagCustomisationAntiNuke = ({title, text, data}) => {
    const [isCustommisation , setIsCustommisation] = useState(data?.enabled);

    return (
        <div className='advance_seting_with_title_wrap'>
            {!!title && 
                <div className='overview_component_content_head'>
                    <h4>{title}</h4>
                    <p>{text}</p>
                </div>
            }
        <div className='status_block_wrap flag_customisation_wrap'>
            <div className='status_block_wrap_bg'></div>
            <img  className='status_block_wrap_img' src="/img/FlagSettings.svg" alt="" />
            <h3>Flag Customisation</h3>
            <div 
            className='status_block_item'
            style={{borderBottom:'1px solid #8D99A3'}}
            >
                <div className='status_block_item_toggler'>
                    <TogglerBody
                    isOn={isCustommisation}
                    setIsOn={setIsCustommisation} keyName={"enabled"} advance />
                    <p>Use advanced parameters</p>
                </div>
            </div>
            <div className='status_block_item flag_customisation_wrap_block_plug'>
                <div className={`status_block_item flag_customisation_wrap_block ${isCustommisation ? '' : 'flag_customisation_wrap_block_blur'}`}>
                    {flagItemArr.map((item, idx) => (
                            <FlagCustomisationItemCounter key={idx}
                            item={item}
                            data={data}
                            />
                    ))}
                </div>
                {!isCustommisation &&
                <div className='flag_customisation_wrap_plug'>
                        <p>Enable Advanced Parameters 🙏🏻</p>
                </div>
                }
            </div>
        </div>
        </div>
    );
};

export default FlagCustomisationAntiNuke;